/**
 * The Skills page's bridge card, formatted from `GET /tooling/info` (`ToolingInfo`).
 *
 * <p>Pure, for the same reason `incarnation.ts` is: the one real decision — is there a bridge to
 * offer at all — and the two copy-button command lines are arithmetic on strings, not rendering,
 * and belong in a helper a test can call directly.
 *
 * <p>The installer never downloads (CB-WI9 / IMPROVEMENTS_2 Part C): it takes `--bridge
 * <path-to-tgz>` / `-Bridge <path>` and refuses to fetch anything itself, because a script that
 * pulled an executable off the network is exactly the thing its own header tells you never to
 * pipe into a shell. So the two commands here name the file the Skills page's own download link
 * just produced — the server's `Content-Disposition` on `/tooling/bridge-<version>.tgz` saves it
 * as `saltseed-bridge-<version>.tgz`, and these lines assume the browser's default `~/Downloads`.
 */

import type { ToolingInfo } from '@/api/types'

export interface BridgeCommandLines {
  /** The filename the tarball download actually saves as — not the URL's `bridge-<version>.tgz`. */
  filename: string
  sh: string
  ps1: string
}

/**
 * `undefined` when this build ships no bridge (`bridge_version` null) — the Skills page then shows
 * the protocol version alone and says the bridge is an improvement, not a requirement, with
 * nothing to copy.
 */
export function bridgeCommandLines(
  info: Pick<ToolingInfo, 'bridge_version'>,
  zoneName: string,
): BridgeCommandLines | undefined {
  const version = info.bridge_version
  if (version === null) return undefined
  const filename = `saltseed-bridge-${version}.tgz`
  const comment = `# ${zoneName}: after downloading ${filename} above`
  return {
    filename,
    sh: `${comment}\n./install.sh --bridge ~/Downloads/${filename}`,
    ps1: `${comment}\n.\\install.ps1 -Bridge $HOME\\Downloads\\${filename}`,
  }
}
